import { NavLink, Outlet } from "react-router-dom"
import { DashboardLayout } from "../../layouts/DashboardLayout"

const TABS = [
  { to: "/mentor/analytics/courses",       label: "Мои курсы" },
  { to: "/mentor/analytics/profile-views", label: "Просмотры профиля" },
]

export const MentorAnalyticsLayout = () => (
  <DashboardLayout title="Аналитика">
    <div className="mb-5 flex gap-1 bg-gray-100/80 p-1 rounded-xl w-fit">
      {TABS.map((t) => (
        <NavLink
          key={t.to}
          to={t.to}
          className={({ isActive }) =>
            `px-4 py-1.5 rounded-lg text-sm font-medium transition-all ${
              isActive ? "bg-white text-gray-900 shadow-sm" : "text-gray-500 hover:text-gray-700"
            }`
          }
        >
          {t.label}
        </NavLink>
      ))}
    </div>
    <Outlet />
  </DashboardLayout>
)
